/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VatRateBase } from '../../models/vat-rate-base';
import { VatRateUpdatedModel } from '../../models/vat-rate-updated-model';

export interface PutApiVatrateV1Id$Json$Params {
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: VatRateBase
}

export function putApiVatrateV1Id$Json(http: HttpClient, rootUrl: string, params: PutApiVatrateV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VatRateUpdatedModel>>> {
  const rb = new RequestBuilder(rootUrl, putApiVatrateV1Id$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VatRateUpdatedModel>>;
    })
  );
}

putApiVatrateV1Id$Json.PATH = '/private/v1/vat-rates/{id}';
